module.exports = __webpack_public_path__ + "media/promo/lum2021/images/3rd-a40205a1169c2e8cc28c7c868ae7eff2.png";